<template >
  <div  style="height: 10vh;overflow: hidden">
    <frame-form  ref="MmManualWorkReportingDetails" componentParam="mes_mold_manual_work_reporting_details"
                 :init-data="parentData"  ></frame-form>
    {{this.parentData.attachments_file_list}}
    <el-row style="margin-left: 80px;" v-if="this.parentData.attachments">
      <el-col >{{("组装图纸：")}}</el-col>
      <el-col :span="22" v-for="item in this.parentData.attachments" :key="item.id" style="width: 100%;height: 100%;margin-left: 40px">
        <el-button text @click="startPage(item,this.parentData.attachments)" class="startPageClass" >{{ item.originalName }}</el-button>
        <el-button text @click="downloadPage(item)" style="color: #00afff;">下载</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: "MmManualWorkReportingDetails",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {

    };
  },
  computed: {},
  mounted() {
    this.getFile()
  },

  methods: {
    async getFile() {
      if (this.parentData.attachments) {
        this.parentData.attachments = await this.$http('mesMoldMmDsService.getFileList', {attachments:this.parentData.attachments})
      }
    },
    startPage(item,itemData) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "prc/PrcPdf";
      windowObj.name = item.originalName.substring(0, item.originalName.length-4);
      windowObj.parentData = {sys_file: item, itemData: itemData};
      windowObj.height = 800 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1350 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow',windowObj)
    },
    //下载文件
    downloadPage(item){
      let url = item?.url;
      if (!url) {
        return
      }
      let name = item.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
  },
}
</script>

<style lang="less" scoped>
.graph_container {
  background-color: white;
}
.startPageClass {
  color: #00afff;
  margin-left: 30px;
  width: 400px;
  justify-content: left
}

</style>